import { render } from "./photodrop-gic3.vue?vue&type=template&id=9d3ec5ac"
import script from "./photodrop-gic3.vue?vue&type=script&lang=js"
export * from "./photodrop-gic3.vue?vue&type=script&lang=js"

import "./photodrop-gic3.vue?vue&type=style&index=0&id=9d3ec5ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__